(() => {
  const initializeSlider = (shell) => {
    if (shell.dataset.bachansSliderReady === 'true') return;

    const track = shell.querySelector('[data-slider-track]');
    const previousButton = shell.querySelector('[data-slider-prev]');
    const nextButton = shell.querySelector('[data-slider-next]');

    if (!track || !previousButton || !nextButton) return;

    shell.dataset.bachansSliderReady = 'true';
    let updateFrame;

    const updateButtons = () => {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previousButton.disabled = track.scrollLeft <= 2;
      nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
    };

    const queueButtonUpdate = () => {
      if (updateFrame) cancelAnimationFrame(updateFrame);
      updateFrame = requestAnimationFrame(updateButtons);
    };

    const scrollTrack = (direction) => {
      const firstCard = track.firstElementChild;
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth;
      const distance = Math.max(cardWidth, track.clientWidth * 0.82);
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previousButton.addEventListener('click', () => scrollTrack(-1));
    nextButton.addEventListener('click', () => scrollTrack(1));
    track.addEventListener('scroll', queueButtonUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(queueButtonUpdate);
      observer.observe(track);
    }

    updateButtons();
  };

  const initializeSliders = (root = document) => {
    if (root.matches?.('[data-bachans-slider]')) initializeSlider(root);
    root.querySelectorAll?.('[data-bachans-slider]').forEach(initializeSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeSliders(), { once: true });
  } else {
    initializeSliders();
  }

  window.addEventListener('load', () => initializeSliders(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initializeSliders(event.target));
})();
